
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Index from "./pages/Index";
import Pricing from "./pages/Pricing";
import NotFound from "./pages/NotFound";
import Demo from "./pages/Demo";
import Publishers from "./pages/Publishers";
import WriteYourBook from "./pages/WriteYourBook";
import FirstDraft from "./pages/FirstDraft";
import AuthorityEngine from "./pages/AuthorityEngine";
import Events from "./pages/Events";
import Qualify from "./pages/Qualify";
import AuthorPromotion from "./pages/AuthorPromotion";
import { AuthProvider } from "./contexts/AuthContext";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import CookiePolicy from "./pages/CookiePolicy";
import ScrollToTop from "./components/ScrollToTop";
import FloatingCTA from "./components/FloatingCTA";
import ScrollProgress from "./components/ScrollProgress";
import PlatformSignIn from "./pages/PlatformSignIn";
import RouteTitle from "./components/RouteTitle";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <RouteTitle />
        <AuthProvider>
          <ScrollProgress />
          <FloatingCTA />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/roi" element={<Navigate to="/pricing" replace />} />
            <Route path="/demo" element={<Demo />} />
            <Route path="/qualify" element={<Qualify />} />
            <Route path="/publishers" element={<Publishers />} />
            <Route path="/write-your-book" element={<WriteYourBook />} />
            <Route path="/first-draft" element={<FirstDraft />} />
            <Route path="/extend" element={<AuthorityEngine />} />
            <Route path="/authority-engine" element={<AuthorityEngine />} />
            <Route path="/events" element={<Events />} />
            <Route path="/author-promotion" element={<AuthorPromotion />} />
            <Route path="/sign-up" element={<Navigate to="/sign-in" replace />} />
            <Route path="/login" element={<Navigate to="/sign-in" replace />} />
            <Route path="/sign-in" element={<PlatformSignIn />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
